const pushToAdobeDataLayer = (eventName, eventData) => {
  window.adobeDataLayer = window.adobeDataLayer || [];

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(`[Analytics] ${eventName}:`, eventData);
  }

  window.adobeDataLayer.push(eventData);
};

export const trackCompareCheckboxClick = (shingle, color) => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'select',
      label: 'shingle comparison',
      detail: 'shingle view',
      type: 'checkbox',
      linkType: 'display action link',
      region: 'roofing shingles near me',
      regionType: 'page body',
    },
    product: [
      {
        type: 'roofing shingle',
        name: `${shingle.name} ${color.name}`.toLowerCase(),
        line: shingle.name.toLowerCase(),
        detail: color.name.toLowerCase(),
      },
    ],
  };

  pushToAdobeDataLayer('trackCompareCheckboxClick', eventData);
};

export const trackAddProductClick = () => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'click',
      label: 'shingle comparison',
      detail: 'add product',
      linkType: 'display action link',
      type: 'button',
      region: 'shingle comparison drawer',
      regionType: 'drawer',
    },
  };

  pushToAdobeDataLayer('trackAddProductClick', eventData);
};

export const trackRemoveProductClick = (shingle, color) => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'click',
      label: 'shingle comparison',
      detail: 'remove product',
      type: 'icon',
      linkType: 'display action link',
      region: 'shingle comparison drawer',
      regionType: 'drawer',
    },
    product: [
      {
        type: 'roofing shingle',
        name: `${shingle.proper_name} ${color.name}`.toLowerCase(),
        line: shingle.proper_name.toLowerCase(),
        detail: color.name.toLowerCase(),
      },
    ],
  };

  pushToAdobeDataLayer('trackRemoveProductClick', eventData);
};

export const trackCompareButtonClick = comparisonUrl => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'click',
      label: 'shingle comparison',
      detail: 'compare',
      linkType: 'internal link',
      location: comparisonUrl,
      type: 'button',
      region: 'shingle comparison drawer',
      regionType: 'drawer',
    },
  };

  pushToAdobeDataLayer('trackCompareButtonClick', eventData);
};

export const trackClearAllClick = comparisonItems => {
  const products = comparisonItems.map(item => ({
    type: 'roofing shingle',
    name: `${item.shingle.proper_name} ${item.shingleColor.name}`.toLowerCase(),
    line: item.shingle.proper_name.toLowerCase(),
    detail: item.shingleColor.name.toLowerCase(),
  }));

  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'click',
      label: 'shingle comparison',
      detail: 'clear all',
      linkType: 'display action link',
      type: 'link',
      region: 'shingle comparison drawer',
      regionType: 'drawer',
    },
    product: products,
  };

  pushToAdobeDataLayer('trackClearAllClick', eventData);
};

export const trackFavoriteShingleSelection = (shingleName, colorName) => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'select',
      label: 'shingle comparison',
      detail: 'compare favorite shingles',
      type: 'drop-down menu',
      linkType: 'display action link',
      region: 'compare shingle colors and lines',
      regionType: 'page body',
    },
    product: [
      {
        type: 'roofing shingle',
        name: `${shingleName} ${colorName}`.toLowerCase(),
        line: shingleName.toLowerCase(),
        detail: colorName.toLowerCase(),
      },
    ],
  };

  pushToAdobeDataLayer('trackFavoriteShingleSelection', eventData);
};

export const trackNewShingleSelection = shingleName => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'select',
      label: 'shingle comparison',
      detail: 'compare new shingle',
      type: 'drop-down menu',
      linkType: 'display action link',
      region: 'compare shingle colors and lines',
      regionType: 'page body',
    },
    product: [
      {
        type: 'roofing shingle',
        name: shingleName.toLowerCase(),
        line: shingleName.toLowerCase(),
        detail: shingleName.toLowerCase(),
      },
    ],
  };

  pushToAdobeDataLayer('trackNewShingleSelection', eventData);
};

export const trackReviewsLinkClick = (shingleName, colorName) => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'click',
      label: 'shingle comparison',
      detail: 'reviews',
      type: 'link',
      linkType: 'internal link',
      region: 'compare shingle colors and lines',
      regionType: 'page body',
    },
    product: [
      {
        type: 'roofing shingle',
        name: `${shingleName} ${colorName}`.toLowerCase(),
        line: shingleName.toLowerCase(),
        detail: colorName.toLowerCase(),
      },
    ],
  };

  pushToAdobeDataLayer('trackReviewsLinkClick', eventData);
};

export const trackChangeColorLinkClick = () => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'click',
      label: 'shingle comparison',
      detail: 'change color',
      type: 'link',
      linkType: 'display action link',
      region: 'compare shingle colors and lines',
      regionType: 'page body',
    },
  };

  pushToAdobeDataLayer('trackChangeColorLinkClick', eventData);
};

export const trackChangeColorDropdownSelection = (shingleName, colorName) => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'select',
      label: 'shingle comparison',
      detail: 'change color',
      type: 'drop-down menu',
      linkType: 'display action link',
      region: 'compare shingle colors and lines',
      regionType: 'page body',
    },
    product: [
      {
        type: 'roofing shingle',
        name: `${shingleName} ${colorName}`.toLowerCase(),
        line: shingleName.toLowerCase(),
        detail: colorName.toLowerCase(),
      },
    ],
  };

  pushToAdobeDataLayer('trackChangeColorDropdownSelection', eventData);
};

export const trackCarouselPreviousArrowClick = () => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'click',
      label: 'shingle comparison',
      detail: 'previous',
      type: 'icon',
      linkType: 'display action link',
      region: 'compare shingle colors and lines',
      regionType: 'page body',
    },
  };

  pushToAdobeDataLayer('trackCarouselPreviousArrowClick', eventData);
};

export const trackCarouselNextArrowClick = () => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'click',
      label: 'shingle comparison',
      detail: 'next',
      type: 'icon',
      linkType: 'display action link',
      region: 'compare shingle colors and lines',
      regionType: 'page body',
    },
  };

  pushToAdobeDataLayer('trackCarouselNextArrowClick', eventData);
};

export const trackCarouselDotClick = () => {
  const eventData = {
    event: 'cta',
    eventInfo: {
      action: 'click',
      label: 'shingle comparison',
      detail: 'dot',
      type: 'icon',
      linkType: 'display action link',
      region: 'compare shingle colors and lines',
      regionType: 'page body',
    },
  };

  pushToAdobeDataLayer('trackCarouselDotClick', eventData);
};
